<template>
  <router-view />
</template>

<script>
import "normalize.css";
import { mapState, mapActions } from "vuex"

export default {
  name: "App",
  created() {
    let $productJson = document.getElementById('CustomizerProductJson');
    const query = (new URLSearchParams(window.location.search.substring(1)));
    const variant_id = query.get('variant');
    const from = query.get('from');
    if ($productJson && Object.keys(this.selectedOptions).length === 0) {
      this.initOptions({ productJson: JSON.parse($productJson.innerHTML), variant_id: parseInt(variant_id), from: from });
    }
  },
  computed: {
    ...mapState([
      "selectedOptions",
    ])
  },
  methods: {
    ...mapActions(["initOptions"])
  }
};
</script>

<style lang="scss">
  @import "./assets/styles/main";
</style>
